var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.3333 20.1667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2083 0C16.4865 0 18.3333 1.84683 18.3333 4.125C18.3333 6.40317 16.4865 8.25 14.2083 8.25C12.972 8.25 11.8635 7.70531 11.1074 6.84367L8.11393 8.57227C8.2024 8.90837 8.25 9.26112 8.25 9.625C8.25 10.2727 8.09979 10.8851 7.83374 11.4306L11.1083 13.3212C11.8643 12.4604 12.9726 11.9167 14.2083 11.9167C16.4865 11.9167 18.3333 13.7635 18.3333 16.0417C18.3333 18.3198 16.4865 20.1667 14.2083 20.1667C11.9302 20.1667 10.0833 18.3198 10.0833 16.0417C10.0833 15.6574 10.1363 15.2855 10.2346 14.9325L6.66642 12.8727C5.96586 13.4217 5.08405 13.75 4.125 13.75C1.84683 13.75 0 11.9032 0 9.625C0 7.34683 1.84683 5.5 4.125 5.5C5.38101 5.5 6.50514 6.06201 7.26172 6.94751L10.2346 5.23145C10.1368 4.87924 10.0833 4.50838 10.0833 4.125C10.0833 1.84683 11.9302 0 14.2083 0ZM14.2083 13.75C12.9427 13.75 11.9167 14.776 11.9167 16.0417C11.9167 17.3073 12.9427 18.3333 14.2083 18.3333C15.474 18.3333 16.5 17.3073 16.5 16.0417C16.5 14.776 15.474 13.75 14.2083 13.75ZM4.125 7.33333C2.85935 7.33333 1.83333 8.35935 1.83333 9.625C1.83333 10.8907 2.85935 11.9167 4.125 11.9167C5.39065 11.9167 6.41667 10.8907 6.41667 9.625C6.41667 8.35935 5.39065 7.33333 4.125 7.33333ZM14.2083 1.83333C12.9427 1.83333 11.9167 2.85935 11.9167 4.125C11.9167 5.39065 12.9427 6.41667 14.2083 6.41667C15.474 6.41667 16.5 5.39065 16.5 4.125C16.5 2.85935 15.474 1.83333 14.2083 1.83333Z",
    fill: "var(--fill-0, #131C20)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.9a92ff57662ffb7591f85a6f0ca4c784.svg";
export { ForwardRef as ReactComponent };